import React, { useMemo } from "react";
import { Icon, Stack, Table, Text } from "@bookingcom/bui-react";
import { BRANDED_FARE_FEATURE_ICON_COMPONENTS, formatFareName } from "@flights/branded-fares";
import { t } from "@bookingcom/lingojs-core";
import { useI18n } from "@bookingcom/lingojs-react";
import { AvailabilityIndicator } from "../../AvailabilityIndicator.js";
const HIGHLIGHT_STYLE = { background: "#F2F8FE" };
function cellStyle(fareIndex, highlightedFareIndex) {
    return {
        textAlign: "center",
        ...(fareIndex === highlightedFareIndex ? HIGHLIGHT_STYLE : undefined)
    };
}
export const BrandedFaresComparisonTable = ({ brandedFaresComparisonTable, highlightedFareIndex, isMultiTraveller, currencyCode }) => {
    const i18n = useI18n();
    const NUMBER_OF_FARES_TO_SHOW = 3;
    const brandedFaresColumn = useMemo(() => brandedFaresComparisonTable.columns.slice(0, NUMBER_OF_FARES_TO_SHOW), [brandedFaresComparisonTable]);
    const brandedFareRows = useMemo(() => brandedFaresComparisonTable.rows, [brandedFaresComparisonTable]);
    const fareColumnWidth = `${60 / brandedFaresColumn.length}%`;
    if (brandedFaresColumn.length === 0) {
        return null;
    }
    return (React.createElement(Table, { attributes: { style: { width: "100%", tableLayout: "fixed" } } },
        React.createElement(Table.Head, null,
            React.createElement(Table.Row, { verticalAlign: "center" },
                React.createElement(Table.Heading, { width: "40%" }, isMultiTraveller ? (React.createElement(Text, { variant: "strong_2", tagName: "strong" }, i18n.trans(t("flights_sr_bf_tabular_hover_total")))) : null),
                brandedFaresColumn.map((fare, fareIndex) => (React.createElement(Table.Heading, { width: fareColumnWidth, key: fareIndex, attributes: { style: cellStyle(fareIndex, highlightedFareIndex) } },
                    React.createElement(Text, { variant: "strong_2", tagName: "strong" }, formatFareName(fare.fareName))))))),
        React.createElement(Table.Body, null, brandedFareRows.map((feature, index) => (React.createElement(Table.Row, { key: index },
            React.createElement(Table.Cell, { width: "40%" },
                React.createElement("div", { style: { display: "flex", alignItems: "start", gap: 4 } },
                    React.createElement(Icon, { size: "medium", svg: BRANDED_FARE_FEATURE_ICON_COMPONENTS[feature.icon], color: "neutral", attributes: { style: { flexShrink: 0 } } }),
                    React.createElement(Text, { variant: "body_2", attributes: { style: { wordBreak: "break-word" } } }, feature.title))),
            feature.values.slice(0, NUMBER_OF_FARES_TO_SHOW).map((fare, fareIndex) => (React.createElement(Table.Cell, { key: fareIndex, attributes: { style: cellStyle(fareIndex, highlightedFareIndex) } },
                React.createElement(Stack, { direction: "column", alignItems: "center", justifyContent: "center", gap: 2 },
                    React.createElement(AvailabilityIndicator, { availability: fare.availability, currencyCode: currencyCode }),
                    fare.label ? React.createElement(Text, { variant: "small_2" }, fare.label) : null))))))))));
};
